/**
 * BVManagementPage.jsx
 * Eigenständige BV-Verwaltungsseite für Admin + Stationsleitung (mit bv_permission)
 * Zeigt NUR Betriebsvereinbarungen – KEIN Zugriff auf Personal, Verträge, etc.
 * URL: /admin/betriebsvereinbarungen
 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DashboardLayout } from '../../components/DashboardLayout';
import { BetriebsvereinbarungenPage } from './BetriebsvereinbarungenPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BVManagementPage() {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    axios.get(`${API}/admin/employees`, { headers })
      .then(r => setEmployees(r.data || []))
      .catch(() => {});
  }, []);

  return (
    <DashboardLayout>
      <div className="p-4 sm:p-6 max-w-4xl mx-auto">
        <BetriebsvereinbarungenPage employees={employees} />
      </div>
    </DashboardLayout>
  );
}
